import { OnboardingWizard } from './components/onboarding-wizard'

// Full-page takeover — the wizard provides its own logo, header, and
// scrollable body, so this route doesn't wrap it in another header.
export const OnboardingPage = () => (
  <div className="fixed inset-0 z-50 flex justify-center overflow-auto bg-background">
    <OnboardingWizard />
  </div>
)
